import React, { useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { Lock } from "lucide-react";

export function PinLock() {
  const { user, locked, unlock, logout } = useAuth();
  const [pin, setPin] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  if (!locked || !user || user === false) return null;

  const submit = async (e) => {
    e.preventDefault();
    if (!pin || busy) return;
    setBusy(true);
    setErr("");
    try {
      await api.post("/auth/pin/verify", { pin });
      setPin("");
      unlock();
    } catch (e2) {
      if (e2.response?.status === 423) {
        logout();
        return;
      }
      setErr(e2.response?.data?.detail || "Incorrect PIN");
      setPin("");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div
      className="fixed inset-0 z-[200] bg-[hsl(var(--background))] flex items-center justify-center p-6"
      data-testid="pin-lock-screen"
    >
      <div className="hud-frame p-8 w-full max-w-sm text-center space-y-6">
        <div>
          <div className="display text-lg tracking-widest">
            COMMAND<span className="text-oud">·</span>CENTER
          </div>
          <div className="mono text-[10px] uppercase tracking-widest text-muted-foreground mt-1 flex items-center justify-center gap-1.5">
            <Lock size={10} /> Session locked
          </div>
        </div>
        <form onSubmit={submit} className="space-y-4">
          <input
            autoFocus
            type="password"
            inputMode="numeric"
            pattern="\d*"
            maxLength={6}
            value={pin}
            onChange={(e) => setPin(e.target.value.replace(/\D/g, ""))}
            placeholder="••••"
            className="hud-input w-full text-center mono !text-2xl tracking-[0.5em]"
            data-testid="pin-lock-input"
          />
          {err && (
            <div className="mono text-[11px] uppercase tracking-widest text-[hsl(var(--oxblood))]" data-testid="pin-lock-error">
              {err}
            </div>
          )}
          <button
            type="submit"
            disabled={busy || pin.length < 4}
            className="hud-btn hud-btn-primary w-full justify-center disabled:opacity-40"
            data-testid="pin-lock-unlock"
          >
            UNLOCK
          </button>
        </form>
        <button
          onClick={logout}
          className="mono text-[10px] uppercase tracking-widest text-muted-foreground hover:text-foreground transition-colors"
          data-testid="pin-lock-signout"
        >
          Sign out instead
        </button>
      </div>
    </div>
  );
}
